export class RpcError extends Error {
  constructor(
    public httpStatus: number,
    public label: string,
    public message: string,
    public body?: any,
  ) {
    super(message);
  }
}
